/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationStateTown } from './OrganizationStateTown';
import {
    OrganizationStateTownFromJSON,
    OrganizationStateTownFromJSONTyped,
    OrganizationStateTownToJSON,
    OrganizationStateTownToJSONTyped,
} from './OrganizationStateTown';

/**
 * 
 * @export
 * @interface CreateOrganizationStateTownsBulk201Response
 */
export interface CreateOrganizationStateTownsBulk201Response {
    /**
     * 
     */
    data?: Array<OrganizationStateTown>;
}

/**
 * Check if a given object implements the CreateOrganizationStateTownsBulk201Response interface.
 */
export function instanceOfCreateOrganizationStateTownsBulk201Response(value: object): value is CreateOrganizationStateTownsBulk201Response {
    return true;
}

export function CreateOrganizationStateTownsBulk201ResponseFromJSON(json: any): CreateOrganizationStateTownsBulk201Response {
    return CreateOrganizationStateTownsBulk201ResponseFromJSONTyped(json, false);
}

export function CreateOrganizationStateTownsBulk201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationStateTownsBulk201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(OrganizationStateTownFromJSON)),
    };
}

export function CreateOrganizationStateTownsBulk201ResponseToJSON(json: any): CreateOrganizationStateTownsBulk201Response {
    return CreateOrganizationStateTownsBulk201ResponseToJSONTyped(json, false);
}

export function CreateOrganizationStateTownsBulk201ResponseToJSONTyped(value?: CreateOrganizationStateTownsBulk201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(OrganizationStateTownToJSON)),
    };
}

